<template>
  <DeleteConfirm
      itemKey="Index"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Indexes from '@/services/indexes'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return Indexes
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť číselník "' + Item.title + '"'
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť číselník "' + Item.title + '"?'
      },
      deleteData() {
        return Indexes
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
